import type { ReactNode } from 'react';
import { DragOverlay, defaultDropAnimationSideEffects } from '@dnd-kit/core';
import type { DropAnimation } from '@dnd-kit/core';
import React from 'react';

const dropAnimationConfig: DropAnimation = {
    sideEffects: defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: '0.4',
            },
        },
    }),
};

export const SortableOverlay: React.FunctionComponent<{ children: ReactNode }> = function ({
    children,
}) {
    return <DragOverlay dropAnimation={dropAnimationConfig}>{children}</DragOverlay>;
};
